'use es6';

import Highcharts from './es-modules/Core/Globals';
import Utilities from './es-modules/Core/Utilities';
import AST from './es-modules/Core/Renderer/HTML/AST';
import './es-modules/Core/Renderer/HTML/HTMLElement';
import './es-modules/Core/Renderer/HTML/HTMLRenderer';
import './es-modules/Core/Axis/Axis';
import './es-modules/Core/Axis/DateTimeAxis';
import './es-modules/Core/Axis/LogarithmicAxis';
import './es-modules/Core/Axis/PlotLineOrBand';
import './es-modules/Core/Tooltip';
import './es-modules/Core/Pointer';
import './es-modules/Core/MSPointer';
import './es-modules/Core/Legend';
import './es-modules/Core/Chart/Chart';
import './es-modules/Extensions/Stacking';
import Series from './es-modules/Core/Series/Series';
import './es-modules/Series/Line/LineSeries';
import './es-modules/Series/Area/AreaSeries';
import './es-modules/Series/Column/ColumnSeries';
import './es-modules/Series/Bar/BarSeries';
import './es-modules/Series/Scatter/ScatterSeries';
import './es-modules/Series/Pie/PieSeries';
import './es-modules/Core/Series/DataLabels';
import './es-modules/Extensions/OverlappingDataLabels';
import './es-modules/Core/Responsive';
import './es-modules/Series/Spline/SplineSeries';

// Utilities
Highcharts.addEvent = Utilities.addEvent;
Highcharts.arrayMax = Utilities.arrayMax;
Highcharts.arrayMin = Utilities.arrayMin;
Highcharts.attr = Utilities.attr;
Highcharts.clearTimeout = Utilities.clearTimeout;
Highcharts.correctFloat = Utilities.correctFloat;
Highcharts.createElement = Utilities.createElement;
Highcharts.css = Utilities.css;
Highcharts.defined = Utilities.defined;
Highcharts.destroyObjectProperties = Utilities.destroyObjectProperties;
Highcharts.discardElement = Utilities.discardElement;
Highcharts.erase = Utilities.erase;
Highcharts.error = Utilities.error;
Highcharts.extend = Utilities.extend;
Highcharts.extendClass = Utilities.extendClass;
Highcharts.find = Utilities.find;
Highcharts.fireEvent = Utilities.fireEvent;
Highcharts.format = Utilities.format;
Highcharts.getMagnitude = Utilities.getMagnitude;
Highcharts.getStyle = Utilities.getStyle;
Highcharts.inArray = Utilities.inArray;
Highcharts.isArray = Utilities.isArray;
Highcharts.isClass = Utilities.isClass;
Highcharts.isDOMElement = Utilities.isDOMElement;
Highcharts.isFunction = Utilities.isFunction;
Highcharts.isNumber = Utilities.isNumber;
Highcharts.isObject = Utilities.isObject;
Highcharts.isString = Utilities.isString;
Highcharts.keys = Utilities.keys;
Highcharts.merge = Utilities.merge;
Highcharts.normalizeTickInterval = Utilities.normalizeTickInterval;
Highcharts.numberFormat = Utilities.numberFormat;
Highcharts.objectEach = Utilities.objectEach;
Highcharts.offset = Utilities.offset;
Highcharts.pad = Utilities.pad;
Highcharts.pick = Utilities.pick;
Highcharts.pInt = Utilities.pInt;
Highcharts.relativeLength = Utilities.relativeLength;
Highcharts.removeEvent = Utilities.removeEvent;
Highcharts.splat = Utilities.splat;
Highcharts.stableSort = Utilities.stableSort;
Highcharts.syncTimeout = Utilities.syncTimeout;
Highcharts.timeUnits = Utilities.timeUnits;
Highcharts.uniqueKey = Utilities.uniqueKey;
Highcharts.useSerialIds = Utilities.useSerialIds;
Highcharts.wrap = Utilities.wrap;

// Class
Highcharts.AST = AST;
Highcharts.Series = Series;

// Additional imports from "highcharts-more"
// https://github.com/highcharts/highcharts/blob/master/ts/masters/highcharts-more.src.js
import './es-modules/Series/Waterfall/WaterfallSeries';
import './es-modules/Series/Bubble/BubbleSeries';

// Imports/dependencies from 'highchart-more" for gauge series
import './es-modules/Core/Axis/RadialAxis';

// AreaRangeSeries must be added before polar.js due to a dependency issue
import './es-modules/Series/AreaRange/AreaRangeSeries';
import './es-modules/Series/ColumnRange/ColumnRangeSeries';
import './es-modules/Extensions/Polar';
import './es-modules/Series/Gauge/GaugeSeries';

// Additional imports from "histogram-bellcurve modules
// https://github.com/highcharts/highcharts/blob/master/ts/masters/modules/histogram-bellcurve.src.js
import './es-modules/Series/Histogram/HistogramSeries';

// Additional imports from "heatmap module"
// https://github.com/highcharts/highcharts/blob/master/ts/masters/modules/heatmap.src.js
import './es-modules/Core/Axis/ColorAxis';
import './es-modules/Mixins/ColorMapSeries';
import './es-modules/Series/Heatmap/HeatmapSeries';

// Sankey Charts
import './es-modules/Series/Sankey/SankeySeries';

// Additional imports from "accessibility"
// https://github.com/highcharts/highcharts/blob/master/ts/masters/modules/accessibility.src.js
import './es-modules/Accessibility/Accessibility';

// Additional imports from "pattern fill module"
// https://github.com/highcharts/highcharts/blob/master/ts/masters/modules/pattern-fill.src.js
import './es-modules/Extensions/PatternFill';
export default Highcharts;